import { createContext } from 'react';
import type { AuthContextType, User } from '@/types/auth';

export const AuthContext = createContext<AuthContextType>({
  error: null,
  getUserInfo: async (): Promise<User> => ({
    id: '',
    name: '',
    givenName: '',
    email: '',
    phone: '',
    extra: {
      roles: [],
      permissions: [],
      id: '',
    },
  }),
  login: async () => false,
  verifyOtp: async () => false,
  logout: () => {
    /* do nothing */
  },
  updateUserData: async () => ({}) as User,
});
